import React from 'react';

import Popover from '@gogame/ui/Popover';

import styled from '../../styled';
import LegacyText from '../Text';

const PopoverTextButton = styled(LegacyText)`
  color: ${(props) => props.theme.palette.primary.main};
  display: flex;
  transition: text-shadow 0.15s linear;
  cursor: pointer;
  text-transform: capitalize;
`;

const withLimit =
  (BaseTextList) =>
  ({
    limit,
    position = 'left',
    title,
    children,
    unitsName,
    count,
    placeholder = '—',
    limitPreview: LimitPreview = BaseTextList,
    withContentTooltip,
    affix,
    skipPopoverContainerPaddings,
    itemProps,
    ...props
  }) => {
    const defaultTitle = (
      <PopoverTextButton size={'13px'} lineBreaks={false} uppercase={true}>
        {count} {unitsName}
      </PopoverTextButton>
    );

    if (count > limit) {
      return (
        <Popover
          hover
          anchor={title || defaultTitle}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
          PaperProps={{
            style: {
              padding: skipPopoverContainerPaddings ? '0' : '16px',
              maxHeight: '350px',
              minWidth: '150px',
              maxWidth: '440px',
              overflow: 'auto',
            },
          }}
        >
          <BaseTextList
            withContentTooltip={withContentTooltip}
            itemProps={itemProps}
            {...props}
          >
            {children}
          </BaseTextList>
        </Popover>
      );
    } else if (count === 0) {
      return (
        <LegacyText {...props} ellipsis={true}>
          {placeholder}
        </LegacyText>
      );
    } else {
      return (
        <LimitPreview
          {...props}
          itemProps={itemProps}
          affix={affix}
          withContentTooltip={withContentTooltip}
        >
          {children}
        </LimitPreview>
      );
    }
  };

export default withLimit;
